export const ACTION_TYPE_USER_AUTHENTICATED = 'USER_AUTHENTICATED'
export const ACTION_TYPE_USER_LOGOUT        = 'USER_LOGOUT'
export const ACTION_TYPE_TOKEN_VALIDATED    = 'TOKEN_VALIDATED'